import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ALL_TEAMS, MockTeam, TeamDraft } from './team-action-mock.data';

// Maquette d'estimation « action d'équipe » : équipes de la session, créées ou modifiées par les modales (perdues au rechargement).
@Injectable({ providedIn: 'root' })
export class TeamActionMockTeamsStore {
  private readonly subject = new BehaviorSubject<MockTeam[]>([...ALL_TEAMS]);
  readonly teams$ = this.subject.asObservable();

  /** Modifie l'équipe en place, ou l'ajoute : les règles et les autres écrans lisent ALL_TEAMS. */
  save(draft: TeamDraft, existing?: MockTeam): MockTeam {
    let team: MockTeam;
    if (existing) {
      team = Object.assign(existing, draft);
    } else {
      team = { ...draft, id: `equipe-${ALL_TEAMS.length + 1}`, usages: [] };
      ALL_TEAMS.push(team);
    }
    this.subject.next([...ALL_TEAMS]);
    return team;
  }
}
